import React, { useContext, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { IconAlertTriangle, IconCreditCard } from '@tabler/icons-react';
import UserContext from '../../../contexts/UserContext';
import RegularizePlanModal from './RegularizePlanModal';

/**
 * Banner de aviso para usuários com acesso restrito por plano irregular.
 * Exibido no topo das páginas permitidas para informar o usuário sobre a situação.
 */
const RestrictedAccessBanner = () => {
  const { isRestrictedAccess, getRestrictionReason } = useContext(UserContext);
  const [showRegularizeModal, setShowRegularizeModal] = useState(false);

  // Se não tem acesso restrito, não renderiza nada
  if (!isRestrictedAccess || !isRestrictedAccess()) {
    return null;
  }

  const reason = getRestrictionReason ? getRestrictionReason() : null;

  const messages = {
    expired: {
      title: "Plano Expirado",
      text: "Seu plano expirou. Renove agora para continuar usando todas as funcionalidades.",
      variant: "danger"
    },
    suspended: {
      title: "Pagamento Pendente",
      text: "Seu plano está suspenso por falta de pagamento. Regularize para evitar a perda de acesso.",
      variant: "warning"
    },
    canceled: {
      title: "Plano Cancelado",
      text: "Seu plano foi cancelado. Adquira um novo plano para voltar a usar a plataforma.",
      variant: "danger"
    },
    no_plan: {
      title: "Sem Plano Ativo",
      text: "Você não possui um plano ativo. Escolha um plano para começar a usar a plataforma.",
      variant: "info"
    }
  };

  const config = messages[reason] || messages.no_plan;

  const handleRegularizeSuccess = () => {
    // Recarregar a página para atualizar o token JWT com as novas informações
    window.location.reload();
  };

  return (
    <>
      <Alert
        variant={config.variant}
        className="mb-4 shadow-sm restricted-access-banner"
        style={{
          position: 'sticky',
          top: '0',
          zIndex: 1000,
          borderRadius: '0 0 8px 8px',
          margin: '0 0 1.5rem 0'
        }}
      >
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center gap-3">
            <IconAlertTriangle size={32} />
            <div>
              <strong>{config.title}</strong>
              <p className="mb-0 small">{config.text}</p>
            </div>
          </div>
          <Button
            variant={config.variant === 'warning' ? 'dark' : 'light'}
            size="sm"
            onClick={() => setShowRegularizeModal(true)}
            className="d-flex align-items-center gap-2"
          >
            <IconCreditCard size={18} />
            Regularizar Agora
          </Button>
        </div>
      </Alert>

      <RegularizePlanModal
        show={showRegularizeModal}
        onHide={() => setShowRegularizeModal(false)}
        reason={reason}
        onSuccess={handleRegularizeSuccess}
      />
    </>
  );
};

export default RestrictedAccessBanner;
